    document.addEventListener('DOMContentLoaded', function () {
      document.body.style.overflow = 'auto';

      const slider = document.querySelector('.extra-addon-slider');
      const prevButton = document.querySelector('.extra-addon-slider-prev');
      const nextButton = document.querySelector('.extra-addon-slider-next');
      
      if (!slider || !prevButton || !nextButton) return;

      let currentIndex = 0;
      let cardWidth;
      let margin = 10;

      function calculateCardsPerView() {
        const containerWidth = document.querySelector('.extra-addon-slider-container').offsetWidth;
        const card = slider.querySelector('.extra-addon-product-card');
        if (!card) return;
        
        const cardsPerView = 3;
        const totalMargin = (cardsPerView - 1) * margin;
        cardWidth = (containerWidth - totalMargin) / cardsPerView;
        
        document.querySelectorAll('.extra-addon-product-card').forEach(card => {
          card.style.width = `${cardWidth}px`;
          card.style.marginRight = `${margin}px`;
        });
        
        slider.style.width = `${(cardWidth + margin) * slider.children.length}px`;
      }

      function updateSlider() {
        const slideAmount = (cardWidth + margin) * currentIndex;
        slider.style.transform = `translateX(-${slideAmount}px)`;
        updateDots();
      }

      const dotsContainer = document.querySelector('.extra-addon-dots');
      
      function initDots() {
        dotsContainer.innerHTML = '';
        const slides = slider.children;
        const cardsPerView = 3;
        const slideStep = 2;
        const maxIndex = slides.length - cardsPerView;
        const dotCount = Math.ceil((maxIndex + 1) / slideStep);
        
        for (let i = 0; i < dotCount; i++) {
          const dot = document.createElement('button');
          dot.className = 'extra-addon-dot';
          dot.addEventListener('click', () => {
            currentIndex = i * slideStep;
            updateSlider();
          });
          dotsContainer.appendChild(dot);
        }
        updateDots();
      }

      function updateDots() {
        const slideStep = 2;
        const activeDotIndex = Math.floor(currentIndex / slideStep);
        const dots = document.querySelectorAll('.extra-addon-dot');
        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === activeDotIndex);
        });
      }

      calculateCardsPerView();
      updateSlider();
      initDots();

      let isDragging = false;
      let startPos = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;

      const handleArrowVisibility = () => {
        if (window.innerWidth <= 768) {
          prevButton.style.display = 'none';
          nextButton.style.display = 'none';
        } else {
          prevButton.style.display = 'block';
        }
      };

      slider.addEventListener('touchstart', touchStart);
      slider.addEventListener('touchmove', touchMove);
      slider.addEventListener('touchend', touchEnd);

      function touchStart(e) {
        if (window.innerWidth > 768) return;
        if (e.target.closest('.extra-addon-quantity')) {
          isDragging = false;
          return;
        }
        isDragging = true;
        startPos = e.touches[0].clientX;
        slider.style.transition = 'none';
      }

      function touchMove(e) {
        if (!isDragging || window.innerWidth > 768) return;
        if (e.target.closest('.extra-addon-quantity')) {
          isDragging = false;
          return;
        }
        const currentPosition = e.touches[0].clientX;
        currentTranslate = prevTranslate + currentPosition - startPos;
        slider.style.transform = `translateX(${currentTranslate}px)`;
      }

      function touchEnd() {
        if (window.innerWidth > 768) return;
        isDragging = false;
        slider.style.transition = 'transform 0.3s ease-in-out';
        
        const movedBy = currentTranslate - prevTranslate;
        if (Math.abs(movedBy) < cardWidth/4) {
          slider.style.transform = `translateX(-${currentIndex * (cardWidth + margin)}px)`;
          return;
        }
        
        if (movedBy < 0) currentIndex += 2;
        else currentIndex -= 2;
        
        currentIndex = Math.max(0, Math.min(currentIndex, slider.children.length - 3));
        prevTranslate = -currentIndex * (cardWidth + margin);
        slider.style.transform = `translateX(-${currentIndex * (cardWidth + margin)}px)`;
        updateDots();
      }

      window.addEventListener('resize', () => {
        handleArrowVisibility();
        calculateCardsPerView();
        updateSlider();
      });

      handleArrowVisibility();

      const quantityInputs = document.querySelectorAll('.extra-addon-quantity .extra-addon-quantity__input');
      quantityInputs.forEach(input => {
        const minusButton = input.previousElementSibling;
        const plusButton = input.nextElementSibling;

        minusButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          input.value = Math.max(1, input.value - 1);
          updateExtraAddonQuantity(input);
        });

        plusButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          input.value = parseInt(input.value) + 1;
          updateExtraAddonQuantity(input);
        });

        input.addEventListener('change', function() {
          this.value = Math.max(1, this.value);
          updateExtraAddonQuantity(this);
        });
      });

      const productCards = document.querySelectorAll('.extra-addon-product-card');
      productCards.forEach(card => {
        const checkbox = card.querySelector('.extra-addon-checkbox');
        const selectButton = card.querySelector('.extra-addon-select-button');
        const minusButton = card.querySelector('.extra-addon-quantity__button[name="minus"]');
        const plusButton = card.querySelector('.extra-addon-quantity__button[name="plus"]');
        const quantityInput = card.querySelector('.extra-addon-quantity__input');

        selectButton.addEventListener('click', (e) => {
          e.stopPropagation(); 
          
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change'));
          updateExtraAddonQuantity(quantityInput); 

          if (checkbox.checked) {
            selectButton.style.display = 'none';
            minusButton.style.display = 'inline-block';
            plusButton.style.display = 'inline-block';
            quantityInput.style.display = 'inline-block';
          } else {
            selectButton.style.display = 'inline-block';
            minusButton.style.display = 'none';
            plusButton.style.display = 'none';
            quantityInput.style.display = 'none';
          }
        });

        card.addEventListener('click', (e) => {
          if (e.target.closest('.extra-addon-quantity')) return;

          selectButton.click(); 
        });
      });

      const checkboxes = document.querySelectorAll('.extra-addon-checkbox');
      checkboxes.forEach(checkbox => {
        const checkmark = checkbox.nextElementSibling?.querySelector('.extra-addon-checkmark');
        const quantityInput = checkbox.closest('.extra-addon-product-card')?.querySelector('.extra-addon-quantity__input');
        
        checkbox.addEventListener('change', function() {
          if (checkmark) {
            checkmark.classList.toggle('checked', this.checked);
          }
          const addonId = this.dataset.extraAddonId;
          const quantity = parseInt(quantityInput?.value || 1);
          toggleExtraAddon(addonId, this.checked ? quantity : 0);
        });
      });

      window.selectedExtraAddons = [];

      function updateExtraAddonQuantity(input) {
        const checkbox = input.closest('.extra-addon-product-card').querySelector('.extra-addon-checkbox');
        if (checkbox?.checked) {
          const addonId = checkbox.dataset.extraAddonId;
          toggleExtraAddon(addonId, parseInt(input.value));
        }
      }

      function toggleExtraAddon(addonId, quantity = 1) {
        const index = window.selectedExtraAddons.findIndex(item => item.id === addonId);
        if (index > -1) {
          if (quantity > 0) {
            window.selectedExtraAddons[index] = { 
              ...window.selectedExtraAddons[index],
              quantity: quantity 
            };
          } else {
            window.selectedExtraAddons.splice(index, 1);
          }
        } else if (quantity > 0) {
          window.selectedExtraAddons.push({ 
            id: addonId, 
            quantity: quantity,
            properties: {
              '_is_extra_addon': 'true',
              '_source_product': '{{ product.id }}'
            }
          });
        }
      }

      let selectedAddons = [];
      const addToCartButton = document.querySelector('[name="add"]');

      if (addToCartButton) {
        addToCartButton.addEventListener('click', function(e) {
          e.preventDefault();
          
          const form = document.querySelector('form[action="/cart/add"]');
          const formData = new FormData(form);
          
          const items = [{
            id: formData.get('id'),
            quantity: formData.get('quantity') || 1
          }];
          
          const allAddons = [...window.selectedAddons, ...window.selectedExtraAddons];
          allAddons.forEach(addon => {
            items.push({
              id: addon.id,
              quantity: addon.quantity,
              ...(addon.properties && { properties: addon.properties })
            });
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
          })
          .then(response => response.json())
          .then(data => {
            if (data.status === 'error') {
              alert(data.description);
            } else {
              window.location.reload();
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
        });
      }

      prevButton.addEventListener('click', () => {
        currentIndex = Math.max(currentIndex - 2, 0);
        updateSlider();
      });

      nextButton.addEventListener('click', () => {
        const maxIndex = slider.children.length - 3; 
        currentIndex = Math.min(currentIndex + 2, maxIndex);
        updateSlider();
      });
    });
